

























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { EventBus } from '@/utils/event-bus'
import { saveAs } from 'file-saver'
import axios from 'axios'

@Component
export default class ViewSlideViewsModal extends Vue {
  showModal = false;
  @Prop() slides?: any[];
  @Prop() markets?: any[] ;
  @Prop() marketKey?: string;
  @Prop() hideActions?: boolean;

  fields: any[] = [
    { key: 'product', label: 'Product' },
    { key: 'pageNo', label: 'Page Number', class: 'text-center' },
    { key: 'title', label: 'Slide Deck' },
    { key: 'downloadCount', label: 'Downloads', class: 'text-center' },
    { key: 'downloadCustomCount', label: 'Custom Deck Downloads', class: 'text-center' },
    { key: 'totalDownloads', label: 'Total Downloads' }
  ]

  get tableFields () {
    if (this.hideActions) {
      return this.fields
    }
    return [
      ...this.fields,
      { key: 'actions', label: '', class: 'text-center' }
    ]
  }

  currentPage = 1;
  perPage = 15;
  selectedProduct = null;
  get listOfProducts () {
    return this.$store.getters.getProducts
  }

  get currentMarket () {
    if (this.markets) {
      const market = this.markets.find((market: any) => market.value === this.marketKey)
      return market.text
    }
    return ''
  }

  get sortedSlides () {
    const slidesToShow = this.slides?.filter((slide: any) => {
      return this.selectedProduct ? slide.productKey === this.selectedProduct : true
    })
    return slidesToShow?.sort((a: { totalDownloads: number; }, b: { totalDownloads: number; }) => b.totalDownloads - a.totalDownloads).slice(0, 100)
  }

  get rows () {
    const slidesToShow = this.slides?.filter((slide: any) => {
      return this.selectedProduct ? slide.productName === this.selectedProduct : true
    })
    return slidesToShow?.length
  }

  onProductChange () {
    const slidesToShow = this.slides?.filter((slide: any) => {
      return this.selectedProduct ? slide.productKey === this.selectedProduct : true
    })
    return slidesToShow?.length
  }

  async downloadSlide (slide: any) {
    EventBus.$emit('show-loader')
    const resp = await axios.post(`slide-deck-pages/download/${slide.slideDeckKey}`, { pageNo: slide.pageNo, trackingKey: slide.trackingKey }, { withCredentials: true, responseType: 'blob' })
    if (!resp || resp.status !== 200) {
      EventBus.$emit('hide-loader')
      return
    }
    const _blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' })
    saveAs(_blob, 'Slide download.pptx')
    if (this.slides) {
      this.slides.find((s: any) => s.key === slide.key).count++
      this.slides.find((s: any) => s.key === slide.key).totalCount++
    }
    EventBus.$emit('hide-loader')
  }
}
